<div class="panel table">
	<div class="splitsing-header">
		<div class="laag-indicator" [class]="generateCssClassForString(laag())"></div>
		<div class="laag-naam">{{ displayService.display(laag()) }}</div>
		<div class="teller">{{ getTeller() }}</div>
	</div>
	<div class="table-header">
		<div class="col-naam">Naam</div>
		@for (jm of maanden(); track jm.nr_maand) {
			<div
				class="col-maand"
				[class.sortable]="isSortMonth(jm)"
				[class.separated]="jm.voorlopig && !$first"
				(click)="toggleSort(isSortMonth(jm))"
				[appTooltip]="isSortMonth(jm) ? 'Sortering ' + (sortDir() === 'asc' ? 'oplopend' : 'aflopend') : undefined"
			>
				<div class="label">
					@if (isSortMonth(jm)) {
						<span class="sort-icon sort-active" data-princexml-ignore data-html2canvas-ignore>
							<app-icon
								[name]="sortDir() === 'asc' ? 'sorteren-oplopend' : 'sorteren-aflopend'"
								color="typography-3"
								size="small"
							></app-icon>
						</span>
					}
					{{ getMaandLabelKort(jm.nr_maand) }}
				</div>
				@if (jm.voorlopig) {
					<app-icon name="trend" size="smallest" color="typography-2"></app-icon>
				}
			</div>
		}
	</div>
	<app-incremental-list
		[itemTemplate]="itemTemplate"
		[emptyTemplate]="emptyTemplate"
		[loaderTemplate]="loaderTemplate"
		[loading]="total() === undefined || elementen().length < total()!"
		[itemSize]="itemHeightPx()"
		[elementen]="elementen()"
		[exportMode]="exportMode()"
		(nextPage)="offset.set($event)"
		[style.height]="calculateHeight()"
	>
		<ng-template #itemTemplate let-element>
			<div class="list-item" [class]="'h-' + itemHeightPx()">
				<div class="list-item-naam" (click)="navigateTo(element)">
					@switch (aanwezigheiduitsplitsing()) {
						@case (AanwezigheidUitsplitsing.LEERLING) {
							<app-pasfoto [pasfoto]="element.ll_pic_pasfoto" size="size-2"></app-pasfoto>
							<div class="naam-nummer">
								<div class="naam">{{ element.ll_fun_volledige_naam }}</div>
								<div class="nummer">{{ element.aw_nr_leerling }}</div>
							</div>
						}
						@case (AanwezigheidUitsplitsing.KLAS) {
							<div class="naam">{{ element.aw_nm_klas }}</div>
						}
						@case (AanwezigheidUitsplitsing.VAK) {
							<div class="naam">{{ element.aw_fun_nm_vak }}</div>
						}
					}
				</div>
				@for (jm of maanden(); track jm.nr_maand) {
					<div
						class="perc"
						[class]="getPercClass(element, jm.nr_maand)"
						[class.striped-s]="jm.voorlopig"
						[class.separated]="jm.voorlopig && !$first"
						[appTooltip]="getTooltip(element, jm)"
					>
						{{ getPercFormatted(element, jm.nr_maand) }}
					</div>
				}
			</div>
		</ng-template>
		<ng-template #emptyTemplate>
			<div class="list-item" [class]="'h-' + itemHeightPx()">
				<div class="empty-list">
					{{ getEmptyState() }}
				</div>
			</div>
		</ng-template>
		<ng-template #loaderTemplate>
			<div class="list-item" [class]="'h-' + itemHeightPx()">
				<div class="empty-list">
					@if (spinnerDelay | async) {
						<app-css-spinner></app-css-spinner>
					}
				</div>
			</div>
		</ng-template>
	</app-incremental-list>
</div>
